import { combineReducers } from 'redux';
import authReducer from './authReducer';
import notificationReducer from './notificationReducer';
import licenseReducer from './licenseReducer';
import ticketsReducer from './ticketsReducer';
import statsReducer from './statsReducer';

const rootReducer = combineReducers({
    auth: authReducer,
    notifications: notificationReducer,
    license: licenseReducer,
    tickets: ticketsReducer,
    stats: statsReducer
});

export default rootReducer;
